import { lazy, Suspense } from 'react';

const LazyCamera = lazy(() => import('./Camera'));

const Camera = () => (
  <Suspense fallback={null}>
    <LazyCamera />
  </Suspense>
);

export default Camera;
